import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3ddb300b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./assets/index.less?vue&type=style&index=0&id=3ddb300b&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddb300b",
  null
  
)

export default component.exports